import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { authService } from './services/auth/authService';
import { setStoreTimeZone } from './utils/dateUtils';
import { installNumberInputScrollGuard } from './utils/numberInputScrollGuard';

// Restore the store's timezone before the first render, so "today" is the
// campground's date rather than the browser's from the very first paint.
// Sessions that predate this field simply fall back to the browser's date.
setStoreTimeZone(authService.getStoreTimezone());

// Scrolling over a focused amount field must never edit the amount.
installNumberInputScrollGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
